export default __webpack_public_path__ + "static/media/scarfilms.19b9c378.PNG";